export default "__VITE_ASSET__B1fjm76b__"